// Placing the order (cart → POST /orders) can fail inside the order handlers
// when the catalog lacks a product or a fitting variant for a cart line. The
// API message names the missing entry ("Product not found in the catalog:
// F Profiel, colour Zwart"); instead of a passing toast the summary page shows
// it in a dialog so the dealer can read it and pass it on.
import types from './checkoutConstants';

// Tag the reducer payload so the page can tell an order-placement failure
// from other Checkout errors (cart load, item delete, ...) that already toast.
export const orderFailurePayload = (response) => ({
    source: types.POST_ORDER_FAILED,
    message: response && typeof response.message === 'string' ? response.message : undefined,
});

export const isOrderPlacementFailure = (error) =>
    !!error && error.source === types.POST_ORDER_FAILED;

// The API detail text when the server explained itself, else the fallback
// (network error / HTML error page without a message body).
export const orderFailureText = (error, fallback) => {
    const message = error && typeof error.message === 'string' ? error.message.trim() : '';
    return message || fallback;
};
